import { formatDateTime } from "@/pages/docsShareLinks/docsShareLinksUtils";
import { VNextButton, VNextCard } from "@/vnext/primitives";

interface GeneratedShareUrlCardProps {
  generatedShareLink: {
    shareUrl: string;
    docPath: string;
    expiresAt: string;
  };
  onCopy: (value: string) => Promise<void>;
}

export function GeneratedShareUrlCard({
  generatedShareLink,
  onCopy,
}: GeneratedShareUrlCardProps) {
  return (
    <VNextCard title="Generated share link">
      <p className="docs-share-links-route__path">
        {generatedShareLink.docPath}
      </p>
      <p className="vnext-muted">
        Expires {formatDateTime(generatedShareLink.expiresAt)}.
      </p>
      <p className="vnext-muted">
        For safety, the full link stays hidden on screen. Use Copy or Open link
        when you need the live URL.
      </p>
      <div className="vnext-inline-actions">
        <VNextButton
          onClick={() => {
            void onCopy(generatedShareLink.shareUrl);
          }}
          tone="secondary"
        >
          Copy
        </VNextButton>
        <VNextButton
          onClick={() => {
            window.open(
              generatedShareLink.shareUrl,
              "_blank",
              "noopener,noreferrer",
            );
          }}
          tone="quiet"
        >
          Open link
        </VNextButton>
      </div>
    </VNextCard>
  );
}
